import _objectSpread from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getinfoData, editinfoData } from "@/api/chuku"; // 确保这个路径是正确的

import crypto from "crypto"; // 引入 crypto 模块

import axios from "axios";
export default {
  data: function data() {
    return {
      formInline: {
        did: "",
        is_deal: null,
        cn: 0
      },
      formValidate: {
        pwd: "",
        city: "",
        use_num: ""
      },
      page: 1,
      page_size: 10,
      total: 0,
      ruleValidate: {
        pwd: [{
          required: true,
          message: this.$t("请输入"),
          trigger: "blur"
        }],
        city: [{
          required: true,
          message: this.$t("请选择"),
          trigger: "change"
        }] // use_num: [
        //   {
        //     required: true,
        //     message: this.$t("请输入"),
        //     trigger: "blur",
        //   },
        // ],

      },
      tableColumns: [{
        title: this.$t("设备ID"),
        key: "did"
      }, {
        title: this.$t("申请原因"),
        key: "reason"
      }, {
        title: this.$t("申请时间"),
        key: "apply_time"
      }, {
        title: this.$t("状态"),
        key: "is_deal"
      }, {
        title: this.$t("失效时间"),
        key: "end_time"
      }, {
        title: this.$t("可用次数"),
        key: "total_num"
      }, {
        title: this.$t("操作"),
        slot: "action",
        width: 150,
        align: "center"
      }],
      tableData: [],
      modalBl: false
    };
  },
  methods: {
    handleSubmit: function handleSubmit() {
      this.getDataInfo(this.page, this.page_size);
    },
    handleReset: function handleReset() {
      this.formInline.did = "";
      this.formInline.cn = 0;
      this.formInline.is_deal = null;
      this.getDataInfo(this.page, this.page_size);
    },
    show: function show(row) {
      this.modalBl = true;
      console.log(row);
      this.formValidate = row;
    },
    handleSubmitModal: function handleSubmitModal(name) {
      var _this = this;

      console.log(this.formValidate);
      this.$refs[name].validate(function (valid) {
        if (valid) {
          var client_id = "I2LrdEvgYleFT6srGHBjmA4DfX1Yl7Hc";
          var client_secret = "c5G89q8bKPOSak5KDZd1RHLh6KSsjaD1";
          var req_time = Math.floor(Date.now() / 1000);
          var new_timestamp = req_time + Number(_this.formValidate.city);

          var md5Hash = _this.generateMD5(client_secret, req_time);

          var params = {
            client_id: client_id,
            req_time: req_time,
            start_time: req_time,
            end_time: new_timestamp,
            client_signkey: md5Hash,
            total_num: Number(_this.formValidate.use_num),
            pwd_id: _this.formValidate.pwd_id,
            status: 1,
            pwd: _this.formValidate.pwd
          };
          var url;

          if (_this.formInline.cn == 0) {
            url = "https://cn3.api.xcthings.com:6443/v3/device/devicepwdreviewpt";
          } else if (_this.formInline.cn == 1) {
            url = "https://us.api.xcthings.com:6443/v3/device/devicepwdreviewpt";
          } else if (_this.formInline.cn == 2) {
            url = "https://eu.api.xcthings.com:6443/v3/device/devicepwdreviewpt";
          } else {
            url = "https://hk.api.xcthings.com:6443/v3/device/devicepwdreviewpt";
          }

          axios.post(url, params).then(function (res) {
            if (res.data.result == 0) {
              _this.modalBl = false;

              _this.$Message.success("设置成功");

              _this.getDataInfo(_this.page, _this.page_size);
            } else {
              _this.$Message.success("设置失败");
            }
          });
        } else {
          _this.$Message.error("Fail!");
        }
      });
    },
    handleResetModal: function handleResetModal(name) {
      this.$refs[name].resetFields();
      this.modalBl = false;
    },
    handlePageChange: function handlePageChange(page) {
      console.log(page);
      this.getDataInfo(page, this.page_size);
    },
    generateMD5: function generateMD5(clientSecret, reqTime) {
      return crypto.createHash("md5").update(clientSecret + reqTime).digest("hex");
    },
    getCookie: function getCookie(name) {
      var value = "; ".concat(document.cookie);
      var parts = value.split("; ".concat(name, "="));
      if (parts.length === 2) return parts.pop().split(";").shift();
      return null;
    },
    getDataInfo: function getDataInfo(page, page_size) {
      var _this2 = this;

      var client_id = "I2LrdEvgYleFT6srGHBjmA4DfX1Yl7Hc";
      var client_secret = "c5G89q8bKPOSak5KDZd1RHLh6KSsjaD1";
      var req_time = Math.floor(Date.now() / 1000);
      var md5Hash = this.generateMD5(client_secret, req_time);
      var token = this.getCookie("token");
      console.log(token);
      var params = {
        client_id: client_id,
        req_time: req_time,
        client_signkey: md5Hash,
        page: page,
        page_size: page_size,
        did: this.formInline.did,
        is_deal: this.formInline.is_deal,
        access_token: token
      };
      var url;

      if (this.formInline.cn == 0) {
        url = "https://cn3.api.xcthings.com:6443/v3/device/devicepwdlistpt";
      } else if (this.formInline.cn == 1) {
        url = "https://us.api.xcthings.com:6443/v3/device/devicepwdlistpt";
      } else if (this.formInline.cn == 2) {
        url = "https://eu.api.xcthings.com:6443/v3/device/devicepwdlistpt";
      } else {
        url = "https://hk.api.xcthings.com:6443/v3/device/devicepwdlistpt";
      }

      axios.post(url, params).then(function (res) {
        console.log("resSAADA", res.data.body.total, res.data.body.items);
        _this2.tableData = []; // 转换时间戳

        _this2.total = res.data.body.total;

        if (res.data.body.total > 0) {
          _this2.tableData = res.data.body.items.map(function (item) {
            return _objectSpread({}, item, {
              apply_time: _this2.formatTimestamp(item.apply_time),
              end_time: item.end_time !== 0 ? _this2.formatTimestamp(item.end_time) : item.end_time,
              is_deal: item.is_deal == 1 ? _this2.$t("未处理") : _this2.$t("已处理")
            });
          });
        }
      });
    },
    formatTimestamp: function formatTimestamp(timestamp) {
      var date = new Date(timestamp * 1000);
      return date.toLocaleString();
    }
  },
  mounted: function mounted() {
    this.getDataInfo(this.page, this.page_size);
  }
};